// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Attività',
    CanDeleteCategoryHasTask: 'Impossibile cancellare una categoria utilizzata nelle attività.',
    CanDeleteVacationTypeDefault: 'Impossibile cancellare il tipo di assenze predefinito.',
    CanDeleteVacationTypeHasVacation: 'Impossibile cancellare il tipo di assenze che presenta delle assenze assegnate.',
    Completed_Projects: 'Progetti completati',
    Completed_Tasks: 'Attività completate',
    Copy_Text: 'Copiare',
    copyPostfix: 'Copiare',
    Edit_Text: 'Modificare',
    filters: 'Filtri',
    next_month: 'Mese successivo',
    next_week: 'Settimana successiva',
    PortfolioLimitError: 'Si è raggiunto il limite di 60 portfolio nell\'Edizione Team. Effettuare l\'aggiornamento ad {brandName} Enterprise Edition.',
    previous_month: 'Mese precedente',
    previous_week: 'Settimana precedente',
    previous_year: 'Anno precedente',
    select: 'Selezionare',
    share: 'Condividere',
    short_quarter0: 'T1',
    short_quarter1: 'T2',
    short_quarter2: 'T3',
    short_quarter3: 'T4',
    this_month: 'Questo mese',
    this_week: 'Questa settimana',
    this_year: 'Quest\'anno',
    today: 'Oggi',
    yesterday: 'Ieri',
};
